import { useMemo } from 'react';
import {
  getCampaignFromUrl,
  persistCampaignToSession,
  CampaignInfo,
} from 'src/util/campaign.util';

/**
 * @usage
 * const { hasCampaign, campaignCode, is10BDayCampaign } = useCampaign();
 */
export const useCampaign = (): CampaignInfo => {
  return useMemo(() => {
    const campaign = getCampaignFromUrl();
    if (campaign.hasCampaign && campaign.campaignCode) {
      persistCampaignToSession(campaign.campaignCode);
    }
    return campaign;
  }, []);
};
